import React from 'react'
import {ReactComponent as CheckIcon} from 'src/v2/assets/icons/check-icon.svg'
import {ReactComponent as WarningIcon} from 'src/v2/assets/icons/warning-error-icon.svg'
import theme from "../../theme/theme"

export const VARIANT_CONFIG_SNACKBAR = {
    success: {
        bgColor: theme.palette.snackBar.primary,
        icon: <CheckIcon style={{color: theme.palette.common.white}}/>,
    },
    error: {
        bgColor: theme.palette.snackBar.error,
        icon: <WarningIcon style={{color: theme.palette.common.white}}/>,
    },
    warning: {
        bgColor: theme.palette.snackBar.warning,
        icon: <WarningIcon style={{color: theme.palette.common.white}}/>,
    },
}
